<div [className]="mainContainerStyles()">
  @if (searchAble) {
    <mat-form-field class="w-full">
      <mat-label>Search</mat-label>
      <input matInput (keyup)="applyFilter($event)" #input />
    </mat-form-field>
  }
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    [matSortActive]="sortOptions?.active || ''"
    [matSortDirection]="sortOptions?.direction || ''"
    [matSortDisableClear]="sortOptions?.disableClear ?? false"
    (matSortChange)="onSortChange($event)"
    [trackBy]="trackBy"
  >
    <caption></caption>
    @for (column of columns; track trackColumnsBy($index, column)) {
      <ng-container [matColumnDef]="column.columnDef">
        @if (!column.templateCell && !templates[column.header]) {
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [disabled]="!column.sorting"
          >
            <h3>{{ column.header }}</h3>
          </th>
          @if (column.formControl) {
            <td mat-cell *matCellDef="let row; let i = index" class="w-1/2">
              <mat-form-field
                style="height: 45px"
                color="primary"
                appearance="outline"
              >
                <input
                  matInput
                  [type]="column.type ?? 'text'"
                  [formControl]="column.formControl(i)"
                />
              </mat-form-field>
            </td>
          } @else {
            <td mat-cell *matCellDef="let row">
              @if (column.cell) {
                {{ column.cell(row) }}
              }
            </td>
          }
        }
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          [disabled]="!column.sorting"
        >
          @if (column.templateCell && templates[column.templateCell]) {
            <h3>{{ column.templateHeader || column.header }}</h3>
          }
        </th>
        <td mat-cell *matCellDef="let row; let i = index">
          @if (column.templateCell && !!templates[column.templateCell]) {
            <ng-container
              *ngTemplateOutlet="
                templates[column.templateCell]!;
                context: { $implicit: row, index: i }
              "
            ></ng-container>
          }
        </td>
        @if (showTotal && column.columnDef === totalColumn) {
          <td mat-footer-cell *matFooterCellDef style="font-weight: bold">
            {{ calculateTotal() }}
          </td>
        } @else {
          <td mat-footer-cell *matFooterCellDef></td>
        }
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [class.clickable-row]="isRowClickable()"
      [ngClass]="rowClassValue(row)"
      (click)="onRowClicked(row)"
    ></tr>
    @if (pagination) {
      <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
    }
    <tr class="mat-row" *matNoDataRow>
      <td
        class="mat-cell no-data-cell"
        [attr.colspan]="displayedColumns.length"
      >
        {{ noDataText }}
      </td>
    </tr>
  </table>

  <mat-paginator
    [style.display]="pagination ? 'block' : 'none'"
    [pageSizeOptions]="paginatorOptions?.pageSizeOptions || [10, 25, 50]"
    [pageIndex]="paginatorOptions?.pageIndex"
    [pageSize]="paginatorOptions?.pageSize"
    [length]="paginatorOptions?.length"
    (page)="paginatorOptions?.page($event)"
    showFirstLastButtons
  ></mat-paginator>
</div>
